module.exports = __webpack_public_path__ + "static/img/Jackson-Ford.415360e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jackson-Ford.jpg
// module id = 3W1Z
// module chunks = 0